export default function KontaktInfo() {
  return (
    <div>
      <h3 className="text-doctio-green font-bold text-[2rem] md:text-[25px]">
        Doctio ApS
      </h3>
      <p className="m-0">Sankt Knuds Vej 6, 1.tv.</p>
      <p className="m-0">1903 Frederiksberg C</p>
      <p className="m-0">CVR-nummer: 42937746</p>
    </div>
  );
}
